import { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { DashboardContext } from '../../../contexts/states/DashboardState';
import { formattedMonth } from '../../../contexts/utils';
import { DriverInfoModal } from '../../Layouts/dashboard layouts/DriverInfoModal';
import { DriversStatsListCon } from '../../Layouts/dashboard layouts/DriversStatsList';
import { GlobalLoading } from '../../Layouts/GlobalLoading';

export const DriversPage = () => {
  const { drivers, initLoading, deleteSuccess } = useContext(DashboardContext);
  const [monthDrivers, setMonthDrivers] = useState([]);
  const [driver, setDriver] = useState('');
  const [driverId, setDriverId] = useState('');

  useEffect(() => {
    const monthIndex = new Date().getMonth();

    if (drivers) {
      const monthDrivers = [];
      drivers.forEach((driver) => {
        if (driver.month - 1 === monthIndex) {
          monthDrivers.push(driver);
        }
      });
      setMonthDrivers(monthDrivers);
    }
  }, [drivers]);

  useEffect(() => {
    if (drivers && driverId) {
      const driver = drivers.find((driver) => {
        return driver.carId === driverId;
      });

      setDriver(driver);
    }
  }, [drivers, driverId]);

  const openDriverInfoModal = (id) => {
    setDriverId(id);

    const modalContainer = document.querySelector('.info-modal-container');
    const backgroundOverlay = document.querySelector('.background-overlay');
    modalContainer.classList.add('active');
    backgroundOverlay.classList.add('active');
  };

  const closeDriverInfoModal = () => {
    const modalContainer = document.querySelector('.info-modal-container');
    const backgroundOverlay = document.querySelector('.background-overlay');
    modalContainer.classList.remove('active');
    backgroundOverlay.classList.remove('active');
  };

  useEffect(() => {
    if (deleteSuccess) {
      closeDriverInfoModal();
      setDriver('');
      setDriverId('');
    }
  }, [deleteSuccess]);

  return (
    <div className='main list'>
      <Helmet>
        <title>All Drivers | LionTaxi Admin</title>
      </Helmet>
      {initLoading && (
        <div className='background-overlay active'>
          <GlobalLoading />
        </div>
      )}
      <header className='desktop'>
        <h2>Drivers</h2>
      </header>
      <div className='cards list'>
        <div className='cards-info'>
          <div>
            <p>All Drivers</p>
            <p>{drivers.length}</p>
          </div>
          <div>
            <p>{formattedMonth} Drivers</p>
            <p>{monthDrivers.length}</p>
          </div>
        </div>
      </div>
      <div className='stats-list'>
        <div className='stats-list-header driver'>
          <p>Username</p>
          <p>Rides</p>
          <p>Car Name</p>
          <p>Star</p>
          <p>Status</p>
        </div>
        <div className='stats-list-body'>
          {drivers.map((driver) => (
            <DriversStatsListCon
              driver={driver}
              key={driver.carId}
              openDriverInfoModal={openDriverInfoModal}
            />
          ))}
        </div>
      </div>

      <div className='info-modal-container'>
        {driver && (
          <DriverInfoModal driver={driver} closeModal={closeDriverInfoModal} />
        )}
      </div>
      {}
    </div>
  );
};
